export default __webpack_public_path__ + "static/media/plus_nav_pink.8af7f668.svg";